import React from 'react';
import styles from '../styles/ModeAlertBar.module.css';

export interface ModeAlertBarProps {
  /** Main message to display in the alert bar */
  message: string;
  /** Optional children for controls (e.g., toggle buttons) rendered on the right side */
  children?: React.ReactNode;
}

/**
 * Shared alert bar component for mode indicators across Spark views.
 * Used by Briefing Assistant, Suggestion Mode, and FSQ Mode.
 */
export const ModeAlertBar: React.FC<ModeAlertBarProps> = ({ message, children }) => {
  return (
    <div className={styles.alertBar}>
      <div className={styles.message}>
        <span>{message}</span>
      </div>
      {children && <div className={styles.controls}>{children}</div>}
    </div>
  );
};

export default ModeAlertBar;
